import React from 'react';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';
import { betSectionBoxesText } from '../../../../enums';

const betValues = ['MIN', 3, '1/2', 2];

export const QuickBtn = ({ limits, t, betAmount, handleChangeInputValue }) => {
  return (
    <div className='bet-type-box'>
      {betValues.map((value) => (
        <button
          key={value}
          className={`bet-btn ${value === 'MIN' && betAmount <= limits.minBet ? 'disabled' : ''}`}
          onClick={() => {
            if (value === betSectionBoxesText.min) {
              handleChangeInputValue(AdditionalInputValueChangingButtons.min);
            } else if (value === betSectionBoxesText.split) {
              handleChangeInputValue(AdditionalInputValueChangingButtons.divide, 2);
            } else if (Number.isInteger(value)) {
              handleChangeInputValue(AdditionalInputValueChangingButtons.multiply, value);
            }
          }}
        >
          {Number.isInteger(value) ? `x${value}` : t(value)}
        </button>
      ))}
    </div>
  );
};
